<template>
  <b-tooltip
    class="w-100"
    :active="serviceErrors.length !== 0"
    :label="errorLabel"
    type="is-danger"
  >
    <BaseButton
      v-if="!hideElementByCondition && !disableQuoteByStatus"
      class="is-color4"
      data-action-type="SERVICE_SIDEBAR:SERVICE_SAVE"
      size="large"
      action="tercery"
      :disabled="disabled"
      :data-test-id="
        constants.DATA_TEST_ID_VALUES.ITINERARY_SERVICE_SIDEBAR_SAVE_BUTTON
      "
      @click.prevent="emitUpdateForm('saveService', true)"
    >
      <i slot="icon" class="is-size mr-5">
        <BaseButtonLock v-if="disableQuoteByStatus" />
        <IconCheck v-else class="icon is-small" />
      </i>
      <p slot="text">Save</p>
    </BaseButton>
  </b-tooltip>
</template>

<script>
import { mapGetters } from "vuex";
import { DATA_TEST_ID_VALUES } from "@/constants/test";

export default {
  name: "BottomButtonSaveSideBar",
  props: {
    parentService: {
      type: Object,
      default: () => {},
    },
    itineraryService: {
      type: Object,
      default: () => {},
    },
    serviceErrors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      constants: {
        DATA_TEST_ID_VALUES,
      },
    };
  },
  computed: {
    ...mapGetters({
      disableQuoteByStatus: "itinerary/getDisableQuoteByStatus",
      hideElementByCondition: "itinerary/getHideElementByCondition",
      loading: "utils/getLoading",
    }),
    disabled() {
      return (
        this.loading ||
        this.disableQuoteByStatus ||
        (!this.parentService && this.itineraryService.service.length > 0) ||
        this.serviceErrors.length > 0
      );
    },
    errorLabel() {
      if (this.serviceErrors.length === 0) return "";
      return this.serviceErrors[0];
    },
  },
  methods: {
    emitUpdateForm(key, value) {
      this.$emit("update", [key, value]);
    },
  },
};
</script>
